<template>
	<div class="setting-join-wesite">
		<div class="pc edit-btn-container">
			<div class="edit-btn-left-panel">
				<!-- <div class="edit-panel-title">PC端聊天按钮设置 <i class="el-icon-close close-btn" @click="goBack"></i></div> -->
				<div class="edit-content-container">
					<div class="edit-module-item">
						<div class="edit-module-title">按钮样式</div>
						<el-radio-group class="edit-radio-group" v-model="editData.icon_pc_style" @change="btnStyleChange(editData.icon_pc_style)">
							<el-radio label="style1">圆形按钮</el-radio>
							<el-radio label="style2">底边按钮</el-radio>
							<el-radio label="style3">侧边按钮</el-radio>
							<el-radio label="style4">图片按钮</el-radio>
							<el-radio label="style5">半边按钮</el-radio>
						</el-radio-group>
					</div>
					<div class="edit-module-item" v-if="editData.icon_pc_style !== 'style4' && editData.icon_pc_style !=
		                'style1' && editData.icon_pc_style !== 'style5'">
						<div class="edit-module-title">按钮内是否显示小图标</div>
						<el-radio-group class="edit-radio-group" v-model="editData.is_small_pc_icon">
							<el-radio label="1">显示</el-radio>
							<el-radio label="0">不显示</el-radio>
						</el-radio-group>
					</div>
					<div class="edit-module-item">
						<div class="edit-module-title">按钮位置</div>
						<el-radio-group class="edit-radio-group" v-model="editData.pc_side">
							<el-radio label="left">页面左侧</el-radio>
							<el-radio label="right">页面右侧</el-radio>
						</el-radio-group>
					</div>
					<div class="edit-module-item" v-if="editData.icon_pc_style !== 'style4'">
						<div class="edit-module-title">颜色选择</div>
						<div class="color-set-item">
							<div>背景色调：</div>
							<el-color-picker @active-change="colorChang('editData.background_pc_color',editData.background_pc_color)"
							 v-model="editData.background_pc_color"></el-color-picker>
						</div>
						<div class="color-set-item">
							<div>边框色调：</div>
							<el-color-picker @active-change="colorChang('editData.background_pc_color',editData.border_pc_color)" v-model="editData.border_pc_color"></el-color-picker>
						</div>
						<div class="color-set-item" v-if="editData.icon_pc_style !=
		                'style1'">
							<div>字体色调：</div>
							<el-color-picker @active-change="colorChang('editData.background_pc_color',editData.font_pc_color)" v-model="editData.font_pc_color"></el-color-picker>
						</div>
					</div>


					<div class="edit-module-item" v-if="(editData.icon_style === 'style1' || (editData.icon_pc_style !== 'style4' && editData.is_small_pc_icon == 1)) && editData.icon_pc_style !== 'style5'">
						<div class="edit-module-title">在线状态</div>
						<ul class="chat-btn-wrapper">
							<li class="icon-btn" :class="onlineIcon == 'CHAT'+item ? 'actived' : ''" @click="statusIconSet('icon_pc_name','CHAT'+item)"
							 v-for="item in
		                        12">
								<i class="FENBOT-MOB-ICONS " :class="'CHAT'+item" :key="item"></i>
							</li>
						</ul>
					</div>
					<div class="edit-module-item" v-if="editData.icon_pc_style !== 'style4' && editData.icon_pc_style !==
		                 'style1'">
						<div class="edit-module-title">在线按钮标题</div>
						<div>
							<el-input @focus="titleInputFocus('icon_pc_title')" v-model="editData.icon_pc_title" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="edit-module-item" v-if="(editData.icon_style === 'style1' || (editData.icon_pc_style !== 'style4' && editData.is_small_pc_icon == 1)) && editData.icon_pc_style !== 'style5'">
						<div class="edit-module-title">离线状态</div>
						<ul class="chat-btn-wrapper">
							<li class="icon-btn" :class="offlineIcon == 'CHAT'+ (item + 20) ? 'actived' : ''" @click="statusIconSet('icon_pc_name_offonline','CHAT'+(item + 20))"
							 v-for="item in 12">
								<i class="FENBOT-MOB-ICONS" :class="'CHAT'+(item+20)" :key="item"></i>
							</li>
						</ul>
					</div>
					<div class="edit-module-item" v-if="editData.icon_pc_style !== 'style4' && editData.icon_pc_style !==
		                 'style1'">
						<div class="edit-module-title">离线按钮标题</div>
						<div>
							<el-input @focus="titleInputFocus('icon_pc_title_offonline')" v-model="editData.icon_pc_title_offonline"
							 placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="edit-module-item slider__buttons" v-if="editData.icon_pc_style !== 'style4' && editData.icon_pc_style !=
		                'style1' ">
						<div class="edit-module-title">自定义圆角</div>
						<div class="radius-set-item">
							<div class="item-label">圆角大小：</div>
							<el-slider class="slider" :max="24" v-model.number="editData.cusytorm_pc_circular_eadb"></el-slider>
							<div class="slider-input">
								<el-input type="number" @input="editInputChange('cusytorm_pc_circular_eadb')" v-model.number="editData.cusytorm_pc_circular_eadb"
								 placeholder="请输入内容"></el-input>
								px
							</div>

						</div>
					</div>

					<div class="edit-module-item" v-if="editData.icon_pc_style == 'style4'">
						<div class="edit-module-title">图片按钮设置</div>
						<div class="image-btn">
							在线状态 <span>(图片建议尺寸：47 * 47)</span>
						</div>
						<div class="image-btn-set-item">
							<div class="image-btn-wrap">
								<img @click="onlineOrOffline = 'online'" :src="editData.icon_pc_img_online" alt="">
							</div>
							<div>
								<div class="wl-btn" @click="uploadImage('online')">点击上传</div>
							</div>
						</div>
						<div class="image-btn">
							离线状态 <span>(图片建议尺寸：47 * 47)</span>
						</div>
						<div class="image-btn-set-item">
							<div class="image-btn-wrap">
								<img @click="onlineOrOffline = 'offline'" :src="editData.icon_pc_img_offonline" alt="">
							</div>
							<div>
								<div class="wl-btn" @click="uploadImage('offline')">点击上传</div>
							</div>
						</div>
						<input type="file" ref="uploadImg" @change="uploadToService" hidden>
					</div>
					<div class="edit-module-item slider__buttons">
						<div class="edit-module-title">透明度</div>
						<div class="radius-set-item slider__buttons">
							<div class="item-label">透明度:</div>
							<el-slider class="slider" v-model="editData.icon_pc_opacity" :step="10" :format-tooltip="formatTooltip"></el-slider>
							<div class="slider-input">
								<el-input type="number" @input="editInputChange('icon_pc_opacity')" minlength="0" v-model.number="editData.icon_pc_opacity"
								 placeholder="请输入内容"></el-input>
								%
							</div>
						</div>
					</div>
					<div class="edit-module-item slider__buttons">
						<div class="edit-module-title">按钮边距</div>
						<div class="radius-set-item" v-if="editData.icon_pc_style !== 'style5'">
							<div class="item-label">侧边距：</div>
							<el-slider class="slider" :max="pcHorizMax" v-model.number="editData.margin_pc_horiz"></el-slider>
							<div class="slider-input">
								<el-input type="number" @input="editInputChange('margin_pc_horiz')" v-model.number="editData.margin_pc_horiz"
								 placeholder="请输入内容"></el-input>
								px
							</div>

						</div>
						<div class="radius-set-item slider__buttons">
							<div class="item-label">下边距：</div>
							<el-slider class="slider" :max="pcVerticalMax" v-model.number="editData.margin_pc_vertical"></el-slider>
							<div class="slider-input">
								<el-input type="number" @input="editInputChange('margin_pc_vertical')" minlength="0" v-model.number="editData.margin_pc_vertical"
								 placeholder="请输入内容"></el-input>
								px
							</div>

						</div>
					</div>

				</div>
				<div class="save-btn" @click="saveBtnChange">保存</div>
			</div>
			<div class="edit-btn-right-panel">
				<div class="pc-preview">
					<!--                圆形样式-->
					<div class="chat-icon btn-circle" v-if="editData.icon_pc_style == 'style1'" :style="styleObj">
						<i class="FENBOT-MOB-ICONS" v-if="onlineOrOffline == 'online'" :class="editData.icon_pc_name"></i>
						<i class="FENBOT-MOB-ICONS" v-if="onlineOrOffline == 'offline'" :class="editData.icon_pc_name_offonline"></i>
					</div>
					<!--                底部样式-->
					<div class="chat-icon btn-bottom" v-if="editData.icon_pc_style == 'style2'" :style="styleObj">
						<div class="btn-box" v-if="onlineOrOffline == 'online'">
							<i class="FENBOT-MOB-ICONS" v-if="editData.is_small_pc_icon == '1'" :class="editData.icon_pc_name"></i> <span>{{editData.icon_pc_title}}</span>
						</div>
						<div class="btn-box" v-if="onlineOrOffline == 'offline'">
							<i class="FENBOT-MOB-ICONS" v-if="editData.is_small_pc_icon == '1'" :class="editData.icon_pc_name_offonline"></i><span>{{editData.icon_pc_title_offonline}}</span>
						</div>

					</div>
					<!--                侧边样式-->
					<div class="chat-icon btn-side" v-if="editData.icon_pc_style == 'style3'" :style="styleObj">
						<div class="btn-box" v-if="onlineOrOffline == 'online'">
							<i class="FENBOT-MOB-ICONS" v-if="editData.is_small_pc_icon == '1'" :class="editData.icon_pc_name"></i> <span>{{editData.icon_pc_title}}</span>
						</div>
						<div class="btn-box" v-if="onlineOrOffline == 'offline'">
							<i class="FENBOT-MOB-ICONS" v-if="editData.is_small_pc_icon == '1'" :class="editData.icon_pc_name_offonline"></i><span>{{editData.icon_pc_title_offonline}}</span>
						</div>

					</div>

					<!--               图片样式-->
					<div class="chat-icon btn-image" v-if="editData.icon_pc_style == 'style4'" :style="styleObj">
						<img v-if="onlineOrOffline == 'online'" :src="editData.icon_pc_img_online" alt="">
						<img v-if="onlineOrOffline == 'offline'" :src="editData.icon_pc_img_offonline" alt="">
					</div>
					
					<!--                半边样式-->
					<div class="chat-icon btn-halfSide" v-if="editData.icon_pc_style == 'style5'" :style="styleObj" :class="[editData.pc_side == 'right'?'halfRight':'halfLeft']">
						<div v-if="editData.pc_side == 'left'" class="sideBox_left">
							<div class="btn-box" v-if="onlineOrOffline == 'online'">
								<span>{{editData.icon_pc_title}}</span>
							</div>
							<div class="btn-box" v-if="onlineOrOffline == 'offline'">
								<span>{{editData.icon_pc_title_offonline}}</span>
							</div>
						</div>
						<div v-if="editData.pc_side == 'right'" class="sideBox_right">
							<div class="btn-box" v-if="onlineOrOffline == 'online'">
								<span>{{editData.icon_pc_title}}</span>
							</div>
							<div class="btn-box" v-if="onlineOrOffline == 'offline'">
								<span>{{editData.icon_pc_title_offonline}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "pc",
		data() {
			return {
				pcHorizMax: 500,
				pcVerticalMax: 200,
				uploadType: '',
				onlineIcon: 'CHAT1',
				offlineIcon: 'CHAT21',
				accept: 'image/gif, image/jpeg, image/png, image/jpg',
				onlineOrOffline: 'online',
				editData: {
					icon_pc_style: 'style1',
					is_small_pc_icon: '1',
					background_pc_color: '#000000',
					border_pc_color: '#000000',
					font_pc_color: '#ffffff',
					icon_pc_name: 'CHAT1',
					icon_pc_name_offonline: 'CHAT21',
					margin_pc_vertical: 0,
					icon_pc_opacity:50,
					margin_pc_horiz: 0,
					cusytorm_pc_circular_eadb: 0,
					icon_pc_title: '',
					icon_pc_title_offonline: '',
					pc_side: 'right',
					icon_pc_img_online: '',
					icon_pc_img_offonline: '',
				},
				initData: {
					icon_pc_style: 'style1',
					is_small_pc_icon: '1',
					background_pc_color: '#000000',
					border_pc_color: '#000000',
					font_pc_color: '#ffffff',
					icon_pc_name: 'CHAT1',
					icon_pc_name_offonline: 'CHAT21',
					margin_pc_vertical: 0,
					icon_pc_opacity:50,
					margin_pc_horiz: 0,
					cusytorm_pc_circular_eadb: 0,
					icon_pc_title: '',
					icon_pc_title_offonline: '',
					pc_side: 'right',
					icon_pc_img_online: '',
					icon_pc_img_offonline: '',
				}


			}
		},
		computed: {
			styleObj: {
				get(val) {
					let styleObject = {}
					if (this.editData.pc_side == 'right') {
						if (this.editData.icon_pc_style != 'style4') {
							styleObject = {
								right: this.editData.margin_pc_horiz + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
								backgroundColor: this.editData.background_pc_color,
								color: this.editData.font_pc_color,
								borderColor: this.editData.border_pc_color,
								borderRadius: this.editData.cusytorm_pc_circular_eadb + 'px',
							}
						}else if(this.editData.icon_pc_style == 'style5'){
							styleObject = {
								right: 0 + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}else {
							styleObject = {
								right: this.editData.margin_pc_horiz + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}

					} else {
						if (this.editData.icon_pc_style != 'style4') {
							styleObject = {
								left: this.editData.margin_pc_horiz / 3 + 'px',
								bottom: this.editData.margin_pc_vertical / 3 + 'px',
								backgroundColor: this.editData.background_pc_color,
								color: this.editData.font_pc_color,
								borderColor: this.editData.border_pc_color,
								borderRadius: this.editData.cusytorm_pc_circular_eadb + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}else if(this.editData.icon_pc_style == 'style5'){
							styleObject = {
								left: 0 + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}else {
							styleObject = {
								left: this.editData.margin_pc_horiz / 3 + 'px',
								bottom: this.editData.margin_pc_vertical / 3 + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}

					}
					return styleObject
				},
				set(val) {

					return val
				}

			}
		},
		watch: {
			editData: {
				handler: function(newVal) {
					let styleObject = {}
					if (this.editData.pc_side == 'right') {
						if (this.editData.icon_pc_style != 'style4') {
							styleObject = {
								right: this.editData.margin_pc_horiz + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
								backgroundColor: this.editData.background_pc_color,
								color: this.editData.font_pc_color,
								borderColor: this.editData.border_pc_color,
								borderRadius: this.editData.cusytorm_pc_circular_eadb + 'px',
							}
						}else if(this.editData.icon_pc_style == 'style5'){
							styleObject = {
								right: 0 + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						} else {
							styleObject = {
								right: this.editData.margin_pc_horiz + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}

					} else {
						if (this.editData.icon_pc_style != 'style4') {
							styleObject = {
								left: this.editData.margin_pc_horiz + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								backgroundColor: this.editData.background_pc_color,
								color: this.editData.font_pc_color,
								borderColor: this.editData.border_pc_color,
								borderRadius: this.editData.cusytorm_pc_circular_eadb + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}else if(this.editData.icon_pc_style == 'style5'){
							styleObject = {
								left: 0 + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						} else {
							styleObject = {
								left: this.editData.margin_pc_horiz + 'px',
								bottom: this.editData.margin_pc_vertical + 'px',
								opacity:this.editData.icon_pc_opacity/100,
							}
						}

					}
					this.styleObj = styleObject
				},
				deep: true //深度监听
			}
		},
		created() {
			this.getBtnConfig()
		},
		mounted() {

		},
		methods: {
			formatTooltip(val){
				return val + '%';
			},
			goBack() {
				this.$router.go(-1)
			},
			// 设置颜色
			colorChang(key, val) {
				// this.editData[key] = val
				this.editData[key] = val.substr(val.length - 7)
			},
			// 输入框
			editInputChange(data) {
				if (this.editData[data].length == 0) {
					return this.editData[data] = 0
				}
			},
			btnStyleChange(type) {
				this.onlineIcon = this.initData.icon_pc_name
				this.offlineIcon = this.initData.icon_pc_name_offonline
				this.onlineOrOffline = 'online'
				this.initData.icon_pc_style = type
				this.editData = Object.assign({}, this.initData)
				if(type == "style5"){
					this.editData.margin_pc_horiz = 0
				}
			},
			// 在线状态-离线状态图标设置
			statusIconSet(type, data) {
				if (type == 'icon_pc_name') {
					this.onlineOrOffline = 'online'
					this.onlineIcon = data
				} else {
					this.onlineOrOffline = 'offline'
					this.offlineIcon = data
				}

				return this.editData[type] = data
			},
			titleInputFocus(type) {
				if (type == 'icon_pc_title') {
					this.onlineOrOffline = 'online'
				} else {
					this.onlineOrOffline = 'offline'
				}
			},
			// 获取配置
			getBtnConfig() {
				this.$http.joinGetBtnConfigAPI().then(res => {
					if (res.status == 1) {
						let getData = res.data
						console.log(getData)
						this.onlineIcon = getData.icon_pc_name ? getData.icon_pc_name : 'CHAT1'
						this.offlineIcon = getData.icon_pc_name_offonline ? getData.icon_pc_name_offonline : 'CHAT21'
						this.editData = {
							icon_pc_style: getData.icon_pc_style ? getData.icon_pc_style : 'style1',
							is_small_pc_icon: getData.is_small_pc_icon ? getData.is_small_pc_icon : '1',
							background_pc_color: getData.background_pc_color ? getData.background_pc_color : '#428EFE',
							border_pc_color:getData.border_pc_color ? getData.border_pc_color : '#428EFE',
							font_pc_color: getData.font_pc_color ? getData.font_pc_color : '#ffffff',
							icon_pc_name: getData.icon_pc_name ? getData.icon_pc_name : 'CHAT1',
							icon_pc_name_offonline: getData.icon_pc_name_offonline ? getData.icon_pc_name_offonline : 'CHAT21',
							margin_pc_vertical: Number(getData.margin_pc_vertical ? getData.margin_pc_vertical : 0),
							icon_pc_opacity:Number(getData.icon_pc_opacity ? getData.icon_pc_opacity*100 : 50),
							margin_pc_horiz:(getData.icon_pc_style !== 'style5' && getData.margin_pc_horiz) ? Number(getData.margin_pc_horiz) : 0,
							cusytorm_pc_circular_eadb: Number(getData.cusytorm_pc_circular_eadb ? getData.cusytorm_pc_circular_eadb : 0),
							icon_pc_title: getData.icon_pc_title ? getData.icon_pc_title : '',
							icon_pc_title_offonline: getData.icon_pc_title_offonline ? getData.icon_pc_title_offonline : '',
							pc_side: getData.pc_side ? getData.pc_side : 'right',
							icon_pc_img_online: getData.icon_pc_img_online ? getData.icon_pc_img_online : '',
							icon_pc_img_offonline: getData.icon_pc_img_offonline ? getData.icon_pc_img_offonline : '',
						}
						this.initData = {
							icon_pc_style: getData.icon_pc_style ? getData.icon_pc_style : 'style1',
							is_small_pc_icon: getData.is_small_pc_icon ? getData.is_small_pc_icon : '1',
							background_pc_color: getData.background_pc_color ? getData.background_pc_color : '#428EFE',
							border_pc_color: getData.border_pc_color ? getData.border_pc_color : '#428EFE',
							font_pc_color: getData.font_pc_color ? getData.font_pc_color : '#ffffff',
							icon_pc_name: getData.icon_pc_name ? getData.icon_pc_name : 'CHAT1',
							icon_pc_name_offonline: getData.icon_pc_name_offonline ? getData.icon_pc_name_offonline : 'CHAT21',
							margin_pc_vertical: Number(getData.margin_pc_vertical ? getData.margin_pc_vertical : 0),
							icon_pc_opacity:Number(this.editData.icon_pc_opacity ? this.editData.icon_pc_opacity*100 : 50),
							margin_pc_horiz:(getData.icon_pc_style !== 'style5' && getData.margin_pc_horiz) ? Number(getData.margin_pc_horiz) : 0,
							cusytorm_pc_circular_eadb: Number(getData.cusytorm_pc_circular_eadb ? getData.cusytorm_pc_circular_eadb : 0),
							icon_pc_title: getData.icon_pc_title ? getData.icon_pc_title : '',
							icon_pc_title_offonline: getData.icon_pc_title_offonline ? getData.icon_pc_title_offonline : '',
							pc_side: getData.pc_side ? getData.pc_side : 'right',
							icon_pc_img_online: getData.icon_pc_img_online ? getData.icon_pc_img_online : '',
							icon_pc_img_offonline: getData.icon_pc_img_offonline ? getData.icon_pc_img_offonline : '',
						}
					}
				})
			},
			/**
			 * 保存修改
			 */
			saveBtnChange() {

				if (this.editData.background_pc_color.length >= 7) {
					this.editData.background_pc_color = this.editData.background_pc_color.substr(this.editData.background_pc_color.length-7)
				}
				if (this.editData.border_pc_color.length >= 7) {
					this.editData.border_pc_color = this.editData.border_pc_color.substr(this.editData.border_pc_color.length-7)
				}
				if (this.editData.font_pc_color.length >= 7) {
					this.editData.font_pc_color = this.editData.font_pc_color.substr(this.editData.font_pc_color.length-7)
				}

				this.editData.icon_pc_opacity = this.editData.icon_pc_opacity ? this.editData.icon_pc_opacity/100 : 0.5
				this.$http.joinSaveBtnConfigAPI(this.editData).then(res => {
					if (res.status == 1) {
						this.getBtnConfig()
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			/**
			 * 上传图片
			 * @param type
			 */
			uploadImage(type) {
				this.uploadType = type
				this.onlineOrOffline = type
				this.$refs.uploadImg.click()
			},
			uploadToService(e) {
				let img = e.target.files[0]
				let type = img.type
				let size = img.size
				if (this.accept.indexOf(type) == -1) {
					this.$message({
						showClose: true,
						message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
						type: 'error',
						duration: 3 * 1000
					})
					return false
				}
				if (size > 5242880) {
					this.$message({
						showClose: true,
						message: '请选择5M以内的图片！',
						type: 'error',
						duration: 3 * 1000
					})
					return false
				}
				let formdata = new FormData()
				formdata.set('file', img)

				this.$http.uploadImageAPI(formdata).then(res => {
					if (res.status == 1) {
						if (this.uploadType == 'online') {
							this.editData.icon_pc_img_online = res.data
						} else {
							this.editData.icon_pc_img_offonline = res.data
						}
						this.$refs.uploadImg.value = ''
					}
				}).catch(error => {
					this.$message({
						message: '上传失败，请重试！',
						type: 'error',
					})
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	.pc {
		margin: -20px;

		.pc-preview {
			width: 640px;
			height: 420px;
			margin: 100px auto 0;
			background-color: #fff;
			position: relative;
			overflow: hidden;
		}
		.btn-box {
			span {
				font-size: 12px;
			}
		}
		.halfRight{
			right: -24px!important;
		}
		.halfLeft{
			left: -24px!important;
		}

	}
	
</style>
